import React, { Component } from "react";
import { Helmet } from "react-helmet";
import FilterBar from "../../collection/common/filter-bar";
import ProductListing from "../../collection/common/product-listing";
import StickyBox from "react-sticky-box";
import Breadcrumb from "../../common/breadcrumb";
import NewProduct from "../../common/new-product";
import Filter from "../../collection/common/filter";
import { getCall, postCall } from "../../../api/post";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getOpenStoreIdApp,
  setMDIInLocal,
} from "../../../store";
import SkeletonLoader from "../common/SkeletonLoader";
import ProductItem from "../dashboard/product-item"; // Add this import at the top

import { connect } from "react-redux";
import {
  getCommonCounter,
  getNotificationCounter,
  getUpdateQuantity,
  getWishlist,
  addToCompare,
  setHeaderCounters,
} from "../../../actions";
import {
  getMerchantInformationUrl,
  getMasterDetailsIdUrl,
  getProductListingUrl,
  getCategoriesUrl,
  getSubCategoriesOfParentCategoryUrl,
  getAddToWishlistUrl,
  getlatestProductListingUrl
} from "../../../services";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import { debuglogger } from "../../../utils/logger";
import AddToCartAnim from "../../../animation/AddToCartAnim";
import NoSpecialProductFoundAnim from "../../../animation/NoSpecialProductFoundAnim";
import QuickViewProductDetailsModal from "../dashboard/quick-view-product-details-modal";
import AddToWishListAnim from "../../../animation/AddToWishListAnim";
import {
  checkAuthAndRedirect,
  getCurrentPath,
} from "../../../utils/cartRedirect";

class Products extends Component {
  state = {
    layoutColumns: 4, // <-- change this from 3 to 4
    productList: [],
    newArrival: [],
    page: 1,
    subCategoryId: "",
    categoryId: "",
    searchValue: "",
    isLoading: false,
    isAddToCartLoading: false,
    sortingOrder: 0,
    offerBanners: [],
    isLoaderVisible: true,
    AppTitle: "",
    showErrorMessageModal: false,
    errorMessage: "",
    masterDetailsObj: {},
    categories: [],
    perPage: 10,
    isPaginationEnableForProductList: false,
    totalPages: 1,
    selectedCategory: {},
    subCategories: [],
    selectedSubCategory: {},
    showAddToCartMessageModal: false,
    addToCartMessage: "",
    searchMaxPrice: "",
    searchMinPrice: "",
    isContentLoaderVisible: false,
    isQuickViewProductDetailsModalShow: false,
    category: {},
    showAddToCompareMessageModal: false,
    addToCompareMessage: "",
  };

  LayoutViewClicked(colums) {
    this.setState({
      layoutColumns: colums,
    });
  }

  handlePerPageChange = (e) => {
    const perPage = parseInt(e.target.value, 10) || 10;
    this.setState(
      { perPage, page: 1, isContentLoaderVisible: true, productList: [] },
      () => {
        this.initProductList().then(() => {
          this.setState({ isContentLoaderVisible: false });
        });
      }
    );
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    this.setState({ isLoading: true }, () => {
      this.initMasterDetailsId().then(() => {
        const { path, params } = this.props.match || {};
        const { id } = params || {};
        if (path && path === "/c/:id") {
          this.setState({ categoryId: id, productList: [], page: 1 }, () => {
            this.initSingleCategry().then(() => {
              this.initSubCategory();
            });
            this.initProductList().then(() => {
              this.setState({ isLoading: false });
            });
          });
        } else if (path && path === "/s/:id") {
          this.setState({ subCategoryId: id, productList: [], page: 1 }, () => {
            this.initSingleSubCategry(id).then(() => {
              const { selectedSubCategory } = this.state;
              const { parentId } = selectedSubCategory;
              this.setState({ categoryId: parentId }, () => {
                this.initSingleCategry().then(() => {
                  this.initSubCategory().then(() => {
                    // Reload all subcategories to maintain expand/collapse functionality
                    this.initAllSubCategories();
                  });
                });
              });
            });

            this.setState({ isLoading: true }, () => {
              this.initProductList().then(() => {
                this.setState({ isLoading: false });
              });
            });
          });
        } else {
          this.setState({ isLoading: true }, () => {
            this.initProductList().then(() => {
              this.setState({ isLoading: false });
            });
          });
        }

        this.initMerchantInfo();
        this.initCategory();
        this.initAllSubCategories(); // Call the new function here
        this.initProductListNewProduct();
        this.props.notificationCounter();
        const { id: userId } = userDetails || {};
        if (userId) {
          this.props.getWishlist(userId);
        }
      });
    });
  }

  UNSAFE_componentWillUpdate(nextProps, newState) {
    // console.log("UNSAFE_componentWillUpdate");
    const { path, params } = this.props.match || {};
    const { path: nextPath, params: nextParams } = nextProps.match || {};
    const { id: idNew } = params || {};
    const { id } = nextParams || {};
    if (nextPath && (path !== nextPath || id !== idNew)) {
      if (nextPath === "/c/:id") {
        this.setState(
          {
            categoryId: id,
            selectedSubCategory: {},
            subCategoryId: "",
            productList: [],
            page: 1,
          },
          () => {
            this.setState({ isLoading: true }, () => {
              this.initSingleCategry().then(() => {
                this.initSubCategory();
              });
              this.initProductList().then(() => {
                this.setState({ isLoading: false });
              });
            });
          }
        );
      } else if (nextPath === "/s/:id") {
        this.setState(
          { subCategoryId: id, isLoading: true, productList: [], page: 1 },
          () => {
            this.initSingleSubCategry(id).then(() => {
              const { selectedSubCategory } = this.state;
              const { parentId } = selectedSubCategory;
              // Set categoryId to parent but preserve subCategoryId
              this.setState(
                {
                  categoryId: parentId,
                  subCategoryId: id, // Ensure subCategoryId is preserved
                },
                () => {
                  this.initSingleCategry().then(() => {
                    this.initSubCategory().then(() => {
                      // Reload all subcategories to maintain expand/collapse functionality
                      this.initAllSubCategories();
                    });
                  });
                }
              );
              this.setState({}, () => {
                this.initProductList().then(() => {
                  this.setState({ isLoading: false });
                });
              });
            });
          }
        );
      } else {
        this.setState(
          {
            isLoading: true,
            subCategoryId: "",
            categoryId: "",
            selectedCategory: {},
            selectedSubCategory: {},
            page: 1,
            searchValue: "",
            sortingOrder: 0,
            isPaginationEnableForProductList: false,
            subCategories: [],
            searchMaxPrice: "",
            searchMinPrice: "",
            productList: [],
          },
          () => {
            this.initAllSubCategories(); // Load all subcategories
            this.initProductList().then(() => {
              this.setState({ isLoading: false });
            });
          }
        );
      }
    }
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
        if (masterDetails && masterDetails.id) {
          // ensure masterDetailsId is stored in localStorage for api headers
          try {
            setMDIInLocal(masterDetails.id);
          } catch (e) {}
        }
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        isMerchantGSTEnable: false,
        merchantInfo: {},
        AppTitle: "",
      });
    } else {
      this.setState({
        merchantInfo,
        AppTitle: merchantInfo.companyname,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initCategory = async () => {
    const categoryUrl = getCategoriesUrl();
    const categories = await getCall(categoryUrl, []);
    if (categories.error) {
      clearLocalStorageReload({ response: categories });
      this.loadErrorMessageAnimation(categories.error.message);
    } else {
      // Double-check that we only have parent categories
      const parentCategories = (categories.data || []).filter(
        (category) => category.parentId === null
      );
      this.setState({ categories: parentCategories });
    }
  };

  // Load all subcategories for expand/collapse functionality
  initAllSubCategories = async () => {
    try {
      // Call API to get only subcategories
      const subCategoryUrl = "categories?filter[where][isSubCategoryData]=1";
      const subCategoryResponse = await getCall(subCategoryUrl, []);
      console.log("Loaded subcategories (API):", subCategoryResponse);
      if (subCategoryResponse.error) {
        clearLocalStorageReload({ response: subCategoryResponse });
        this.loadErrorMessageAnimation(subCategoryResponse.error.message);
      } else {
        const subcategories = subCategoryResponse.data || [];
        this.setState({ subCategories: subcategories });
      }
    } catch (error) {
      console.error("Error loading all subcategories:", error);
    }
  };

  initSubCategory = async () => {
    const { selectedCategory } = this.state;
    const { id } = selectedCategory || {};
    if (id) {
      const subcategoryUrl = getSubCategoriesOfParentCategoryUrl(id);
      const subCategories = await getCall(subcategoryUrl, []);
      if (subCategories.error) {
        clearLocalStorageReload({ response: subCategories });
        this.loadErrorMessageAnimation(subCategories.error.message);
      } else {
        // Don't overwrite the subCategories state - it's managed by initAllSubCategories
      }
    }
  };

  initSingleCategry = async () => {
    const { categoryId } = this.state;
    if (categoryId !== null) {
      const singleCategoryUrl = "categories/" + categoryId;
      const singleCategory = await getCall(singleCategoryUrl, []);
      if (singleCategory.error) {
        clearLocalStorageReload({ response: singleCategory });
        this.loadErrorMessageAnimation(singleCategory.error.message);
        if (singleCategory.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        this.setState({ selectedCategory: singleCategory });
      }
    }
  };

  initSingleSubCategry = async () => {
    const { subCategoryId } = this.state;
    if (subCategoryId !== null) {
      const singleCategoryUrl = "categories/" + subCategoryId;
      const singleCategory = await getCall(singleCategoryUrl, []);
      if (singleCategory.error) {
        clearLocalStorageReload({ response: singleCategory });
        this.loadErrorMessage(singleCategory.error.message);
        if (singleCategory.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        this.setState({ selectedSubCategory: singleCategory });
      }
    }
  };

  initSingleAsParentCategry = async (product) => {
    const { category } = product || {};
    const { parentId } = category || {};
    if (parentId) {
      const singleCategoryUrl = "categories/" + parentId;
      const singleCategory = await getCall(singleCategoryUrl, []);
      if (singleCategory.error) {
        clearLocalStorageReload({ response: singleCategory });
        this.loadErrorMessage(singleCategory.error.message);
        if (singleCategory.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        this.setState({ category: singleCategory });
      }
    }
  };

  initProductListNewProduct = async () => {
    const productListUrl =
      "products?filter[include]=productbrand&filter[include]=productmedia&filter[include]=category&filter[where][productstatus]=1&filter[where][availablequantity][gt]=0&filter[order][0]=created DESC&filter[skip]=0&filter[limit]=20";

    const newArrival = await getCall(productListUrl, []);
    if (newArrival.error) {
      clearLocalStorageReload({ response: newArrival });
      this.loadErrorMessageAnimation(newArrival.error.message);
      if (newArrival.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      console.log("New Arrival Products:", newArrival);
      this.setState({ newArrival });
    }
  };

  openFilter = () => {
    document.querySelector(".collection-filter").style = "left: -15px";
  };

  openFilter = () => {
    document.querySelector(".collection-filter").style = "left: -15px";
  };

  initProductList = async () => {
    try {
      const {
        categoryId,
        subCategoryId,
        sortingOrder,
        page,
        productList,
        searchValue,
        perPage,
        searchMinPrice,
        searchMaxPrice,
      } = this.state;
      const productListUrl = getlatestProductListingUrl(
        categoryId,
        sortingOrder,
        subCategoryId,
        searchValue,
        page,
        perPage,
        searchMinPrice,
        searchMaxPrice
      );

      console.log("[Products] Product listing URL:", productListUrl);
      const response = await getCall(productListUrl, []);
      this.setState({ isContentLoaderVisible: false });
      this.setState({ isLoading: false });
      this.setState({ isLoaderVisible: false });
      if (response.error) {
        clearLocalStorageReload({ response });
        this.loadErrorMessageAnimation(response.error.message);
        if (response.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else {
        // New API shape: { data: [...], pagination: { page, per_page, total_pages, total }}
        const data = response.data || [];
        const pagination = response.pagination || {};
        const respPage = pagination.page || page;
        const respPerPage = pagination.per_page || perPage;
        const totalPages = pagination.total_pages || 1;

        this.setState({
          isPaginationEnableForProductList: respPage < totalPages,
          totalPages,
          page: respPage,
        });

        // For numbered pagination we should replace the list with the
        // current page's data instead of concatenating previous pages.
        this.setState({ productList: data });
      }
    } catch (error) {
      console.error("Error in initProductList:", error);
      this.setState({ isLoading: false });
    }
  };

  handleCategoryWiseProductListFilter = () => {
    this.setState(
      {
        page: 1,
        isLoading: true,
      },
      () => {
        this.initSubCategory();
        this.initProductList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handleSubCategoryWiseProductListFilter = () => {
    this.setState(
      {
        page: 1,
        isLoading: true,
      },
      () => {
        this.initProductList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handleSortingProductFilter = (order) => {
    this.setState(
      {
        sortingOrder: order,
        page: 1,
        isContentLoaderVisible: true,
        productList: [],
      },
      () => {
        this.initProductList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handlePagination = (skip) => {
    // now expects page number
    this.setState({ page: skip, isContentLoaderVisible: true }, () => {
      this.initProductList();
    });
  };

  onSearchProduct = (value) => {
    this.setState(
      {
        searchValue: value,
        skip: 0,
        isContentLoaderVisible: true,
        productList: [],
      },
      () => {
        this.initProductList();
      }
    );
  };

  onSearchPrice = (min, max) => {
    this.setState(
      {
        searchMinPrice: min,
        searchMaxPrice: max,
        page: 1,
        isContentLoaderVisible: true,
        productList: [],
      },
      () => {
        this.initProductList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  onSearchMaxPrice = (value) => {
    this.setState({ searchMaxPrice: value, page: 1, isLoading: true }, () => {
      this.initProductList();
    });
  };

  onSearchMinPrice = (value) => {
    this.setState({ searchMinPrice: value, page: 1, isLoading: true }, () => {
      this.initProductList();
    });
  };

  clearFilter = () => {
    this.setState(
      {
        searchMinPrice: "",
        searchMaxPrice: "",
        searchValue: "",
        page: 1,
        isContentLoaderVisible: true,
        productList: [],
      },
      () => {
        this.initProductList().then(() => {
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handleLoader = (isLoading) => {
    this.setState({ isLoading });
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  handleOnClickOfParentCategory = (category) => {
    const { id } = category;
    this.setState(
      {
        selectedCategory: category,
        categoryId: id,
        subCategoryId: "",
        selectedSubCategory: {},
        isLoading: true,
      },
      () => {
        this.props.history.replace(`/c/${id}`);
        // Reload subcategories for the selected category
        this.initSubCategory().then(() => {
          this.handleCategoryWiseProductListFilter();
          this.setState({ isLoading: false });
        });
      }
    );
  };

  handleOnClickOfSubCategory = (subCategory) => {
    const { id } = subCategory || {};

    this.setState(
      { selectedSubCategory: subCategory, subCategoryId: id },
      () => {
        this.props.history.replace(`/s/${id}`);
        this.handleSubCategoryWiseProductListFilter();
      }
    );
  };

  loadAddToCartMessageAnimation = (message) => {
    this.setState({
      addToCartMessage: message,
      showAddToCartMessageModal: true,
    });
  };

  clearFilterOnClickOfAll = () => {
    this.setState({ isLoading: true }, () => {
      this.props.history.replace("/products"); // <-- Add this line
      this.initCategory().then(() => {
        this.setState({
          isLoading: false,
          selectedCategory: {},
          categoryId: "",
          subCategoryId: "",
          selectedSubCategory: {},
        });
        this.initAllSubCategories(); // Reload all subcategories
        this.initSingleCategry();
        this.initProductList();
      });
    });
  };

  addToCart = async (product, qty, isInquiry) => {
    try {
      // Check authentication first
      const currentPath = getCurrentPath(this.props);
      if (!checkAuthAndRedirect(this.props, currentPath)) {
        return; // User was redirected to login
      }

      this.setState({ isAddToCartLoading: true });
      let userDetails = loadUserDetailsFromLocalStorage();
      if (!isOpenStoreIdExist() && userDetails === undefined) {
        return;
      } else {
        userDetails = userDetails === undefined ? {} : userDetails;
      }
      const { id, cityId } = userDetails;
      const openStoreId = getOpenStoreIdApp();
      let userId = openStoreId ? openStoreId : id;

      const addtocartUrl = isInquiry
        ? "orders/productInquiry"
        : "orders/addtocart";

      let addtocartObj = {
        orderstatus: 1,
        inshoppingcart: 1,
        userId,
        totalamount: isInquiry ? 0 : product.price * qty,
        orderdetails: [
          {
            quantity: qty,
            productId: product.id,
          },
        ],
        cityId: cityId,
        date: new Date(),
      };

      const addToCartResponse = await postCall(addtocartUrl, addtocartObj);
      this.setState({ isAddToCartLoading: false });

      if (addToCartResponse.error) {
        this.loadErrorMessageAnimation(addToCartResponse.error.message);
        if (addToCartResponse.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
      } else if (
        addToCartResponse.message &&
        (addToCartResponse.message === "Sorry! Product is out of stock" ||
          addToCartResponse.message ===
            "Sorry! Product is not availble as per given quantity")
      ) {
        // Handle out of stock or insufficient quantity message
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_out_of_stock") ||
            addToCartResponse.message ||
            "Sorry! Product is out of stock"
        );
        return;
      } else {
        this.loadAddToCartMessageAnimation(
          isInquiry
            ? getValueFromLanguageObject("str_add_to_inquiry_successfully") ||
                "Product inquiry added successfully"
            : getValueFromLanguageObject("str_add_to_cart_successfully") ||
                "Product added to cart successfully."
        );
        this.hideQuickViewProductDetailsModal();

        // Add a small delay to ensure backend has finished updating the counter
        setTimeout(() => {
          this.props.counter();
          if (this.props.updateQuantity) {
            this.props.updateQuantity();
          }
          this.fetchHeaderCounters();
        }, 500);
      }
      this.setState({ page: 1 }, () => {
        this.initProductList();
      });
    } catch (error) {
      this.setState({ isAddToCartLoading: false });
    }
  };

  showQuickViewProductDetailsModal = () => {
    this.setState({ isQuickViewProductDetailsModalShow: true });
  };

  hideQuickViewProductDetailsModal = () => {
    this.setState({ isQuickViewProductDetailsModalShow: false });
  };

  handleClickOfQuickView = (product) => {
    this.setState({ product }, () => {
      this.initSingleAsParentCategry(product);
      this.showQuickViewProductDetailsModal();
    });
  };

  loadAddToWishListMessageAnimation = (message) => {
    this.setState({
      addToWishListMessage: message,
      showAddToWishListMessageModal: true,
    });
  };

  onAddToWishlistClicked = async (product) => {
    try {
      const addtowishlistUrl = "v2/wishlists";
      const currentPath = getCurrentPath(this.props);
      if (!checkAuthAndRedirect(this.props, currentPath)) {
        return;
      }
      this.setState({ isLoading: true });
      const addToWishlistObj = { productId: product.id };
      const response = await postCall(addtowishlistUrl, addToWishlistObj);
      this.setState({ isLoading: false });

      if (response && response.success) {
        const successMessage =
          getValueFromLanguageObject("str_add_to_wishlist_successfully") ||
          response.message ||
          "Product added to wishlist successfully";
        this.loadAddToWishListMessageAnimation(successMessage);
        this.props.getWishlist(loadUserDetailsFromLocalStorage().id);
        await this.fetchHeaderCounters();
      } else if (
        response.detail &&
        response.detail.responseMessageCode === "WISHLIST_DUPLICATE"
      ) {
        this.loadAddToWishListMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_wishlist") ||
          (response.detail.responseData && response.detail.responseData.message) ||
          "Product already in wishlist."
        );
      } else if (
        response.responseData &&
        response.responseData.messageCode === "WISHLIST_DUPLICATE"
      ) {
        this.loadAddToWishListMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_wishlist") ||
          response.responseData.message ||
          "Product already in wishlist."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_wishlist") ||
          response.message ||
          "Failed to add to wishlist."
        );
      }
    } catch (error) {
      this.setState({ isLoading: false });
      if (
        error &&
        (error.responseMessageCode === "WISHLIST_DUPLICATE" ||
          (error.responseData && error.responseData.messageCode === "WISHLIST_DUPLICATE"))
      ) {
        this.loadAddToWishListMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_wishlist") ||
          (error.responseData && error.responseData.message) ||
          "Product already in wishlist."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_wishlist") ||
          "An error occurred while adding to wishlist."
        );
      }
    }
  };

  onAddToCompareClicked = async (product) => {
    try {
      const addToCompareUrl = "v2/product-comparisons";
      const body = { productId: product.id };
      const response = await postCall(addToCompareUrl, body);

      if (response && response.success) {
        const successMessage =
          getValueFromLanguageObject("str_add_to_compare_successfully") ||
          response.message ||
          "Product added to compare successfully";
        this.setState({
          addToCompareMessage: successMessage,
          showAddToCompareMessageModal: true,
        });
        await this.fetchHeaderCounters();
      } else if (
        response.detail &&
        response.detail.responseMessageCode === "COMPARISON_DUPLICATE"
      ) {
        // Handles error structure: response.detail.responseMessageCode
        this.setState({
          errorMessage:
            getValueFromLanguageObject("str_product_already_in_comparison") ||
            (response.detail.responseData && response.detail.responseData.message) ||
            "Product already in comparison list.",
          showErrorMessageModal: true,
        });
      } else if (
        response.responseData &&
        response.responseData.messageCode === "COMPARISON_DUPLICATE"
      ) {
        // Handles error structure: response.responseData.messageCode
        this.setState({
          errorMessage:
            getValueFromLanguageObject("str_product_already_in_comparison") ||
            response.responseData.message ||
            "Product already in comparison list.",
          showErrorMessageModal: true,
        });
      } else if (
        response.responseData &&
        response.responseData.messageCode === "COMPARISON_LIMIT_REACHED"
      ) {
        this.setState({
          errorMessage:
            getValueFromLanguageObject("str_comparison_limit_reached") ||
            (response.responseData && response.responseData.message) ||
            "Comparison list limit reached.",
          showErrorMessageModal: true,
        });
      } else {
        this.setState({
          errorMessage:
            getValueFromLanguageObject("str_error_adding_to_compare") ||
            response.message ||
            "Failed to add product to comparison.",
          showErrorMessageModal: true,
        });
      }
    } catch (error) {
      // Handles error in catch block
      console.error("Error adding to compare:", error);
      if (
        error &&
        (error.responseMessageCode === "COMPARISON_DUPLICATE" ||
          (error.responseData && error.responseData.messageCode === "COMPARISON_DUPLICATE"))
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_product_already_in_comparison") ||
          (error.responseData && error.responseData.message) ||
          "Product already in comparison list."
        );
      } else if (
        error &&
        (error.responseMessageCode === "COMPARISON_LIMIT_REACHED" ||
          (error.responseData && error.responseData.messageCode === "COMPARISON_LIMIT_REACHED"))
      ) {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_comparison_limit_reached") ||
          (error.responseData && error.responseData.message) ||
          "Comparison list limit reached."
        );
      } else {
        this.loadErrorMessageAnimation(
          getValueFromLanguageObject("str_error_adding_to_compare") ||
          "An error occurred while adding the product to comparison."
        );
      }
    }
  };

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        return;
      }
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {}
  };

  render() {
    const {
      isLoading,
      showAddToCartMessageModal,
      addToCartMessage,
      showErrorMessageModal,
      errorMessage,
      productList,
      newArrival,
      isPaginationEnableForProductList,
      limit,
      layoutColumns,
      selectedCategory,
      selectedSubCategory,
      categories,
      subCategories,
      categoryId,
      subCategoryId,
      product,
      category,
      isQuickViewProductDetailsModalShow,
      masterDetailsObj,
      showAddToWishListMessageModal,
      addToWishListMessage,
      AppTitle, // <-- ADD THIS LINE
    } = this.state;
    const { page, totalPages, perPage } = this.state;
    const { symbol, isInquiry } = this.props;

    // Set card width and grid columns based on layoutColumns
    let cardWidth = 290;
    let colClass = "col-xl-3 col-lg-4 col-md-6 col-12"; // 4 columns by default
    let isListView = false;

    if (layoutColumns === 2) {
      cardWidth = 440;
      colClass = "col-lg-6 col-md-6 col-sm-12 col-12"; // 2 columns
    } else if (layoutColumns === 3) {
      cardWidth = 340;
      colClass = "col-xl-3 col-lg-4 col-md-6 col-12"; // 3 columns
    } else if (layoutColumns === 12) {
      cardWidth = "100%";
      colClass = "col-lg-12 col-12";
      isListView = true;
    }

    const { showBreadcrumb = true } = this.props; // <-- add this line

    return (
      <>
        <div>
          {/*SEO Support*/}
          <Helmet>
            <title>
              {AppTitle} |{" "}
              {getValueFromLanguageObject("str_products")
                ? getValueFromLanguageObject("str_products")
                : "Products"}{" "}
            </title>
            <meta
              name="description"
              content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses."
            />
          </Helmet>

          {/* Only show breadcrumb if prop is true */}
          {showBreadcrumb && (
            <Breadcrumb
              title={
                getValueFromLanguageObject("str_products")
                  ? getValueFromLanguageObject("str_products")
                  : "Products"
              }
              parentCategory={selectedCategory}
              subCategory={selectedSubCategory}
              style={{ marginBottom: "8px" }}
              onClickOfParentCategory={this.handleOnClickOfParentCategory}
            />
          )}

          {/* Show skeleton loader over the whole section when loading */}
          {isLoading ? (
            <div className="container">
              <SkeletonLoader type="productpage" />
            </div>
          ) : (
            <section className="section-b-space">
              <div className="collection-wrapper">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-3 collection-filter">
                      <StickyBox offsetTop={20} offsetBottom={20}>
                        <div>
                          <Filter
                            categories={categories}
                            subCategories={subCategories}
                            categoryId={categoryId}
                            subCategoryId={subCategoryId}
                            onClickOfParentCategory={
                              this.handleOnClickOfParentCategory
                            }
                            onClickOfSubCategory={
                              this.handleOnClickOfSubCategory
                            }
                            clearFilterOnClickOfAll={
                              this.clearFilterOnClickOfAll
                            }
                          />

                          {/* New Product Card with rounded corners and shadow */}
                          <div className="card">
                            <NewProduct newProducts={newArrival} />
                          </div>
                        </div>
                      </StickyBox>
                      {/*side-bar banner end here*/}
                    </div>

                    <div className="col-lg-9 collection-content">
                      <div className="page-main-content">
                        <div className="card p-4">
                          {/* Filter and Search */}
                          <div className="d-flex flex-md-row flex-column align-items-center mb-3 border-bottom pb-3">
                            <div className="flex-grow-1 pr-md-3 w-100 mb-3 mb-md-0">
                              <input
                                type="text"
                                className="form-control rounded"
                                id="search-product"
                                value={this.state.searchValue}
                                onChange={(e) => {
                                  // Only allow text input
                                  this.setState({
                                    searchValue: e.target.value,
                                  });
                                }}
                                placeholder={
                                  getValueFromLanguageObject(
                                    "str_search_products"
                                  ) || "Search Products"
                                }
                              />
                            </div>
                            <div className="flex-grow-1 pr-md-3 w-100 mb-3 mb-md-0">
                              <input
                                value={this.state.searchMinPrice}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control rounded"
                                id="search-min-price"
                                min="0"
                                onChange={(e) => {
                                  // Only allow digits
                                  const val = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                  this.setState({ searchMinPrice: val });
                                }}
                                onPaste={(e) => {
                                  // Prevent pasting non-numeric
                                  const paste = e.clipboardData.getData("text");
                                  if (!/^\d+$/.test(paste)) e.preventDefault();
                                }}
                                placeholder={
                                  getValueFromLanguageObject("str_min_price") ||
                                  "Min Points"
                                }
                              />
                            </div>
                            <div className="flex-grow-1 pr-md-3 w-100 mb-3 mb-md-0">
                              <input
                                value={this.state.searchMaxPrice}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control rounded"
                                id="search-max-price"
                                min="0"
                                onChange={(e) => {
                                  // Only allow digits
                                  const val = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                  this.setState({ searchMaxPrice: val });
                                }}
                                onPaste={(e) => {
                                  // Prevent pasting non-numeric
                                  const paste = e.clipboardData.getData("text");
                                  if (!/^\d+$/.test(paste)) e.preventDefault();
                                }}
                                placeholder={
                                  getValueFromLanguageObject("str_max_price") ||
                                  "Max Points"
                                }
                              />
                            </div>
                            <div className="d-flex flex-nowrap w-100">
                              <button
                                onClick={() => {
                                  const {
                                    searchMinPrice,
                                    searchMaxPrice,
                                  } = this.state;
                                  this.onSearchPrice(
                                    searchMinPrice,
                                    searchMaxPrice
                                  );
                                }}
                                className="btn btn-solid mr-3 rounded"
                                type="submit"
                              >
                                {getValueFromLanguageObject("apply") || "Apply"}
                              </button>
                              <button
                                onClick={() => this.clearFilter()}
                                className="btn btn-outline rounded"
                                type="button"
                              >
                                {getValueFromLanguageObject("str_clear") ||
                                  "Clear"}
                              </button>
                            </div>
                          </div>
                          {/* Layout Controls */}
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <FilterBar
                                productList={productList}
                                handleSortingProductFilter={
                                  this.handleSortingProductFilter
                                }
                                onLayoutViewClicked={(colmuns) =>
                                  this.LayoutViewClicked(colmuns)
                                }
                              />
                            </div>
                            {/* Per-page control moved below product list (above pagination) */}
                          </div>
                          {/* Products Listing */}
                          <div
                            className="mt-4 row product-wrapper-grid gap-3"
                            style={{ justifyContent: "flex-start" }}
                          >
                            {productList.length > 0 ? (
                              productList.map((product, index) => (
                                <div
                                  key={product.id || index}
                                  className={colClass}
                                >
                                  <ProductItem
                                    product={product}
                                    symbol={symbol}
                                    onAddToCartClicked={this.addToCart}
                                    onAddToWishlistClicked={
                                      this.onAddToWishlistClicked
                                    }
                                    addToCompare={this.onAddToCompareClicked}
                                    handleClickOfQuickView={
                                      this.handleClickOfQuickView
                                    }
                                    masterDetailsObj={masterDetailsObj}
                                    isInquiry={isInquiry}
                                    cardWidth={cardWidth}
                                    isListView={isListView}
                                    searchValue={this.state.searchValue}
                                  />
                                </div>
                              ))
                            ) : (
                              <div style={{ width: "100%" }}>
                                <NoSpecialProductFoundAnim />
                              </div>
                            )}
                          </div>

                          {/* Per-page + Pagination (inline) */}
                          {totalPages > 1 && (
                            <div className="d-flex align-items-center justify-content-between mt-3 flex-wrap">
                              <div className="d-flex align-items-center mb-2 mb-md-0">
                                <label className="mr-2 mb-0">Per page:</label>
                                <select
                                  className="form-control"
                                  style={{ minWidth: "88px" }}
                                  value={perPage}
                                  onChange={this.handlePerPageChange}
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>
                              </div>

                              <nav aria-label="Product pagination" className="mb-0">
                                <ul className="pagination mb-0">
                                  <li
                                    className={`page-item ${page <= 1 ? "disabled" : ""}`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => this.handlePagination(page - 1)}
                                      disabled={page <= 1}
                                    >
                                      Prev
                                    </button>
                                  </li>

                                  {Array.from({ length: totalPages }).map((_, i) => {
                                    const p = i + 1;
                                    const showAll = totalPages <= 7;
                                    const inRange = Math.abs(p - page) <= 2;
                                    if (!showAll && !inRange && p !== 1 && p !== totalPages) {
                                      if (p === 2 && page > 4) {
                                        return (
                                          <li key={`ellipsis-left`} className="page-item disabled">
                                            <span className="page-link">…</span>
                                          </li>
                                        );
                                      }
                                      if (p === totalPages - 1 && page < totalPages - 3) {
                                        return (
                                          <li key={`ellipsis-right`} className="page-item disabled">
                                            <span className="page-link">…</span>
                                          </li>
                                        );
                                      }
                                      return null;
                                    }
                                    return (
                                      <li
                                        key={p}
                                        className={`page-item ${p === page ? "active" : ""}`}
                                      >
                                        <button
                                          className="page-link"
                                          onClick={() => this.handlePagination(p)}
                                        >
                                          {p}
                                        </button>
                                      </li>
                                    );
                                  })}

                                  <li
                                    className={`page-item ${page >= totalPages ? "disabled" : ""}`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() => this.handlePagination(page + 1)}
                                      disabled={page >= totalPages}
                                    >
                                      Next
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                            </div>
                          )}
                          {/*  */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* Confirmation dialog for add to cart */}
          {showAddToCartMessageModal && (
            <AddToCartAnim
              show={showAddToCartMessageModal}
              message={addToCartMessage}
              onClose={() =>
                this.setState({ showAddToCartMessageModal: false })
              }
            />
          )}

          {/* Error dialog */}
          {showErrorMessageModal && (
            <ErrorMessageAnimationModal
              show={showErrorMessageModal}
              message={errorMessage}
              onClose={() => this.setState({ showErrorMessageModal: false })}
            />
          )}

          {/* Add to wishlist animation */}
          {showAddToWishListMessageModal &&
            (console.log(
              "Rendering AddToWishListAnim with message:",
              addToWishListMessage
            ),
            (
              <AddToWishListAnim
                show={showAddToWishListMessageModal}
                message={addToWishListMessage}
                onClose={() =>
                  this.setState({ showAddToWishListMessageModal: false })
                }
              />
            ))}

          {/* Quick View Product Details Modal */}
          <QuickViewProductDetailsModal
            product={this.state.product}
            masterDetailsObj={this.state.masterDetailsObj}
            isQuickViewProductDetailsModalShow={
              this.state.isQuickViewProductDetailsModalShow
            }
            handleCloseQuickViewProductDetailsModal={
              this.hideQuickViewProductDetailsModal
            }
            onAddToCartClicked={this.addToCart}
            category={this.state.category}
          />

          {/* Confirmation dialog for add to compare */}
          {this.state.showAddToCompareMessageModal && (
            <AddToCartAnim
              show={this.state.showAddToCompareMessageModal}
              message={this.state.addToCompareMessage}
              onClose={() =>
                this.setState({
                  showAddToCompareMessageModal: false,
                  addToCompareMessage: "",
                })
              }
            />
          )}

          {/* ...other overlays/modals... */}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({ wishlist: state.settings.wishlist });

export default connect(mapStateToProps, {
  counter: getCommonCounter,
  notificationCounter: getNotificationCounter,
  updateQuantity: getUpdateQuantity,
  getWishlist: getWishlist,
  addToCompare: addToCompare,
  setHeaderCounters,
})(withRouter(Products));
